module.exports = __webpack_public_path__ + "media/subscriber-logos/pge-21a489a0.png";